<script>

import axios from 'axios';

export default class LocationRepository{
    
    async getVisitas(page,token,rawdata){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const data = rawdata;
        const response = await axios.post(baseURL, data,{ headers: headers });
        return response;

    }

    async sendLocation(page, rawdata, token) {
        const baseURL = page;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        try {
            const response = await axios.post(baseURL, rawdata, { headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar proposta:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async  alterVisitStatus(page,token,id,rawdata) {
        
        console.log(id)
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = rawdata;
        const response = await axios.post(baseURL,data,{ headers });
        return response;
       
    }

}
</script>
